import { render, staticRenderFns } from "./StandardClauseCreate.vue?vue&type=template&id=474de518&scoped=true&"
import script from "./StandardClauseCreate.vue?vue&type=script&lang=js&"
export * from "./StandardClauseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474de518",
  null
  
)

export default component.exports